import register from '../register';
import dom from './util/dom';
import {
  validateEmail,
  validatePhone,
  addError,
  removeError,
  isEmpty,
  isNotSubmit,
  shouldValidate
} from './util/form-utils';
import phoneMask from './util/phone-mask';

let $ = document.querySelector.bind( document );

let $formTop;
let $formContainer;
let $formBody;
let $error;
let $serviceableThanks = $('.thanks.is-serviceable');
let $notServiceableThanks = $('.thanks.not-serviceable');

let validators = {
  email: validateEmail,
  phone: validatePhone
};

class FormController {

  constructor({ form, phone, extended = false }) {
    this.extended = extended;

    this.$form = $( form );
    this.$phone = this.$form.querySelector( phone );
    this.$submit = this.$form.querySelector('button[type="submit"]');
    this.$inputs = [
      ...this.$form.querySelectorAll('input:not([type="radio"]), select')
    ];

    this.$form.addEventListener( 'submit', this.onSubmit.bind( this ) );

    phoneMask( this.$phone );
  }

  onSubmit( e ) {
    e.preventDefault();

    let payload;

    if ( this.validate() ) {
      this.$submit.disabled = true;
      this.$submit.classList.add('loading');
      payload = this.getPayload();
      this.submitWaitlist( payload );
    }
  }

  validate() {
    return !this.$inputs
    .filter( shouldValidate )
    .map( removeError )
    .filter( isInvalid )
    .map( addError ).length;
  }

  getPayload() {
    return this.$inputs.filter( isNotSubmit ).reduce( inputReducer, {} );
  }

  onError() {
    $error.classList.remove('hidden');
    this.$submit.disabled = false;
    this.$submit.classList.remove('loading');
  }

  submitWaitlist( payload ) {
    const ext        = !!this.extended;
    const additional = {};

    if ( ext ) {
      additional.name  = payload.property_manager_name;
      additional.email = payload.property_manager_email;
      additional.phone = payload.property_manager_phone;
      delete payload.property_manager_name;
      delete payload.property_manager_email;
      delete payload.property_manager_phone;
    }

    const opts = { url: '/serviceable', method: 'POST' };

    dom.ajax( opts, payload, ( err, res ) => {
      if ( err ) {
        return this.onError();
      }

      // KCE note: i hate myself
      if ( payload.flow === 'freeinternet_serviceable' ) {
        acumen.track('web-submit-serviceable');
      } else {
        const parts = [
          `${ res.street_number } ${ res.street }`,
          res.city,
          res.state,
          res.postal_code
        ];

        acumen.track( 'web-submit-unavailable', {
          place_id: res._id || null,
          first_name: res.first_name || null,
          last_name: res.last_name || null,
          address: parts.join(', '),
          unit: res.apt || null,
          phone: res.phone || null,
          email: res.email || null
        });
      }

      acumen.identify({ email: payload.email });

      if ( ext ) {
        additional.waitlist_id = res._id;
        this.submitReferral( additional );
      } else {
        this.onSuccess();
      }
    });
  }

  submitReferral( payload ) {
    const opts = { url: '/api/referred-decision-makers', method: 'POST' };

    dom.ajax( opts, payload, err => {
      if ( err ) {
        return this.onError();
      }
      this.onSuccess();
    });
  }

  onSuccess() {
    const flow = this.$form.querySelector('input[name="flow"]').value;

    $formBody.style.display = 'none';
    $formTop.style.display = 'none';
    $formContainer.classList.add('no-border');

    if ( flow === 'freeinternet_serviceable' ) {
      $serviceableThanks.classList.remove('hidden');
      return;
    }

    $notServiceableThanks.classList.remove('hidden');
  }

}

function init() {
  // basic form
  new FormController({
    form: '#serviceable-form',
    phone: '#inp-phone',
    extended: false
  });

  // extended form w/ property manager info
  new FormController({
    form: '#serviceable-form-extended',
    phone: '#inp-property-manager-phone',
    extended: true
  });

  $formTop = $('.check-serviceability__top-section');
  $formContainer = $('.check-serviceability__form-section');
  $formBody = $('.form-body');
  $error = $('.serviceable__submit-error');
}

function isInvalid( inp ) {
  let validate = validators[ inp.dataset.validate ];
  return typeof validate === 'function' ?
    !validate( inp.value ) : isEmpty( inp );
}

function inputReducer( obj, inp ) {
  obj[ inp.name ] = inp.type === 'checkbox' ?
    inp.checked : ( inp.value || null );
  return obj;
}

register( 'serviceable-form-free-internet', init );

export default undefined;
